import { StickyNote, Check, X, Loader2 } from "lucide-react";
import { fmtAgo } from "./visitorMeta";

/** Renders the right-most "Notes" cell: editor mode, view mode, or empty "Add note" CTA. */
export default function NoteCell({
    visitor,
    isEditing,
    isSaving,
    draftNote,
    setDraftNote,
    onOpen,
    onSave,
    onCancel,
}) {
    const shortId = visitor.session_id.slice(0, 8);

    if (isEditing) {
        return (
            <div className="flex items-start gap-2" data-testid={`note-editor-${shortId}`}>
                <textarea
                    value={draftNote}
                    onChange={(e) => setDraftNote(e.target.value)}
                    rows={2}
                    maxLength={2000}
                    placeholder="Private note (e.g. 'Called Tue, voicemail')"
                    className="flex-1 rounded-lg bg-white border border-[#E5DFD3] focus:border-[#0E2A47] focus:outline-none px-2.5 py-1.5 text-[12.5px] resize-none"
                    autoFocus
                    data-testid={`note-input-${shortId}`}
                />
                <div className="flex flex-col gap-1.5">
                    <button
                        onClick={() => onSave(visitor.session_id)}
                        disabled={isSaving}
                        className="h-7 w-7 rounded-full bg-[#0E2A47] text-white grid place-items-center hover:bg-[#08182B] disabled:opacity-50"
                        title="Save note"
                        data-testid={`note-save-${shortId}`}
                    >
                        {isSaving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}
                    </button>
                    <button
                        onClick={onCancel}
                        disabled={isSaving}
                        className="h-7 w-7 rounded-full border border-[#E5DFD3] text-[#6F6B63] grid place-items-center hover:border-[#0E2A47]"
                        title="Cancel"
                        data-testid={`note-cancel-${shortId}`}
                    >
                        <X className="h-3.5 w-3.5" />
                    </button>
                </div>
            </div>
        );
    }

    if (visitor.notes) {
        return (
            <button
                onClick={() => onOpen(visitor)}
                className="text-left group w-full"
                data-testid={`note-view-${shortId}`}
            >
                <p className="text-[12.5px] text-[#1A2230] leading-snug line-clamp-2 group-hover:text-[#0E2A47]">
                    {visitor.notes}
                </p>
                <p className="text-[10.5px] text-[#6F6B63] mt-0.5">
                    Updated {fmtAgo(visitor.notes_updated_at)} · click to edit
                </p>
            </button>
        );
    }

    return (
        <button
            onClick={() => onOpen(visitor)}
            className="inline-flex items-center gap-1.5 text-[12px] text-[#6F6B63] hover:text-[#0E2A47] rounded-full border border-dashed border-[#E5DFD3] hover:border-[#0E2A47] px-2.5 py-1 transition-colors"
            data-testid={`note-add-${shortId}`}
        >
            <StickyNote className="h-3.5 w-3.5" />
            Add note
        </button>
    );
}
